import { Injectable } from '@angular/core'
import { ConfigService } from '../services/config.service'
import {
   HttpRequest,
   HttpHandler,
   HttpEvent,
   HttpInterceptor,
} from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

   get jwtToken() {
      return this.config.currentConfig?.apiJwt
   }

   constructor(private config: ConfigService) { }

   intercept(
      request: HttpRequest<unknown>,
      next: HttpHandler
   ): Observable<HttpEvent<unknown>> {
      if(this.jwtToken) {
         request = request.clone({
            setHeaders:{
               'Authorization': 'Bearer ' + sessionStorage.getItem(this.jwtToken)
            }
         })}
      return next.handle(request)
   }
}
